import * as React from 'react';
import cx from 'clsx';
import { useContactFeaturesContext } from './internal/ContactFeaturesContext';
import * as styles from './styles.module.css';

/**
 * Компонент списка отличительных признаков
 * Если элемент не вещается, то он пропадает
 *
 * Адаптивный
 */
export function ContactFeatures(_ref) {
  var features = _ref.features;

  var _useContactFeaturesCo = useContactFeaturesContext(),
      background = _useContactFeaturesCo.background;

  return /*#__PURE__*/React.createElement("dl", {
    className: cx(styles['features'], styles["bg_" + background])
  }, features.map(function (_ref2, i) {
    var title = _ref2.title,
        value = _ref2.value;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles['item']
    }, /*#__PURE__*/React.createElement("dt", null, title), /*#__PURE__*/React.createElement("dd", null, value));
  }));
}